export default __webpack_public_path__ + "static/media/P1.80f1abb1.webp";